import { Action, createReducer, on } from '@ngrx/store';
import {
  LOGIN_OTP_SEND,
  LOGIN_OTP_SEND_SUCCESS,
  LOGIN_OTP_SEND_FAIL,
  LOGIN_OTP_VERIFY,
  LOGIN_OTP_VERIFY_SUCCESS,
  LOGIN_OTP_VERIFY_FAIL,
  LOGIN_OTP_RESET,
  LOGIN_OTP_PRELOAD,
} from './login-otp.actions';

export interface ILoginOtpState {
  esito: string | null;
  loading: boolean;
  seed: string | null;
  telefono: string | null;
  username: string | null;
  error: any | null;
  msgCode: string | null;
  otpTtlSeconds: number;
  maxTentativi: number;
}

const initialState: ILoginOtpState = {
  esito: null,
  loading: false,
  seed: null,
  telefono: null,
  username: null,
  error: null,
  msgCode: null,
  otpTtlSeconds: 300,
  maxTentativi: 5,
};

const reducerBase = createReducer(
  initialState,

  on(LOGIN_OTP_SEND, (state, { telefono }) => ({
    ...state,
    loading: true,
    esito: null,
    error: null,
    telefono: telefono,
    msgCode: null
  })),
  

  on(LOGIN_OTP_SEND_SUCCESS, (state, { esito, seed, otpTtlSeconds, telefono, maxTentativi, msgCode }) => ({
    ...state,
    loading: false,
    esito,
    seed,
    telefono: telefono ?? state.telefono,
    error: null,
    otpTtlSeconds: otpTtlSeconds ?? state.otpTtlSeconds,
    maxTentativi: maxTentativi ?? state.maxTentativi,
    msgCode: msgCode ?? null
  })),

  on(LOGIN_OTP_SEND_FAIL, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(LOGIN_OTP_VERIFY, (state) => ({
    ...state,
    loading: true,
    esito: null,
    error: null,
    msgCode: null
  })),

  on(LOGIN_OTP_VERIFY_SUCCESS, (state, { esito, username, msgCode }) => ({
    ...state,
    loading: false,
    esito,
    username,
    msgCode: msgCode ?? null,
    error: null,
  })),

  on(LOGIN_OTP_VERIFY_FAIL, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(LOGIN_OTP_PRELOAD, (state, { telefono }) => ({
    ...state,
    telefono, 
  })),

  on(LOGIN_OTP_RESET, () => initialState)
);

export function loginOtpReducer(
  state: ILoginOtpState | undefined,
  action: Action
): ILoginOtpState {
  return reducerBase(state, action);
}
